import type { DashboardViewKey } from '../../types/schema'

export type { DashboardViewKey }

export type DashboardView =
  | 'Timeline'
  | 'Constellation'
  | 'Radar'
  | 'Sandfall'
  | 'Journey'
  | 'Grid'
  | 'Heatmap'
  | 'Stripboard'
  | 'WarRoom'
  | 'Leaderboard'
  | 'Perimeter'
  | 'LootDrop'
  | 'Flowband'
  | 'Burnshore'
  | 'Cadence'

export const DOCK_VIEW_LABELS: Record<DashboardView, { icon: string; label: string; tooltip: string }> = {
  Timeline: { icon: 'T', label: 'Timeline', tooltip: 'Chronological plan with pan, zoom and cursor pings.' },
  Constellation: { icon: 'C', label: 'Constellation', tooltip: 'Interactive nodes and connections that map how work depends on other work.' },
  Radar: { icon: 'R', label: 'Radar', tooltip: 'Sweeping radar that surfaces the most urgent items in the current window.' },
  Sandfall: { icon: 'B', label: 'Sandfall', tooltip: 'Weighted burndown of remaining work as it drains from top to bottom.' },
  Journey: { icon: 'J', label: 'Journey', tooltip: 'Guided path through the plan with milestone stops.' },
  Grid: { icon: 'G', label: 'Grid', tooltip: 'Contribution grid at day granularity, coloured by activity.' },
  Heatmap: { icon: 'H', label: 'Heatmap', tooltip: 'Contribution heatmap grouped by week, coloured by activity.' },
  Stripboard: { icon: 'S', label: 'Stripboard', tooltip: 'Kanban strip of checklist items grouped by workflow status.' },
  WarRoom: { icon: 'W', label: 'War Room', tooltip: 'Blueprint layout showing owners and blockers of active work.' },
  Leaderboard: { icon: 'R', label: 'Reliability', tooltip: 'Reliability rankings of collaborators over the current window.' },
  Perimeter: { icon: 'P', label: 'Perimeter', tooltip: 'Countdown of items nearing their due-date perimeter.' },
  LootDrop: { icon: 'L', label: 'Loot Drop', tooltip: 'Sequence of lanes releasing wins over the current window.' },
  Flowband: { icon: 'F', label: 'Flowband', tooltip: 'Share of remaining weight per parent, over time.' },
  Burnshore: { icon: 'B', label: 'Burnshore', tooltip: 'Weighted burndown per parent, with checklist occurrences.' },
  Cadence: { icon: 'D', label: 'Cadence', tooltip: 'Completion-time distribution across fixed buckets.' },
}

export const DASHBOARD_VIEW_MAP: Record<DashboardViewKey, DashboardView> = {
  TIMELINE: 'Timeline',
  CONSTELLATION: 'Constellation',
  RADAR: 'Radar',
  SANDFALL: 'Sandfall',
  JOURNEY: 'Journey',
  GRID: 'Grid',
  HEATMAP: 'Heatmap',
  STRIPBOARD: 'Stripboard',
  WARROOM: 'WarRoom',
  LEADERBOARD: 'Leaderboard',
  PERIMETER: 'Perimeter',
  LOOTDROP: 'LootDrop',
  FLOWBAND: 'Flowband',
  BURNSHORE: 'Burnshore',
  CADENCE: 'Cadence',
}
